import cloneDeep from 'lodash/cloneDeep';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import { TYPE_BOOLEAN } from '../../TemplateBuilder/const/templates';



const fileProp = 'originFileObj';

const appendToFormData = (formData, key, value) => {
  if (value === '') {
    formData.append(key, null);
  } else if (isObject(value) && !isArray(value)) {
    Object.entries(value).forEach(([ objKey, objValue ]) => {
      formData.append(`${key}[${objKey}]`, objValue);
    });
  } else {
    formData.append(key, value);
  }
};

const mkTemplateDynamicFormData = (values, language, fields = []) => {
  const clonedValues = cloneDeep(values);
  const formData = new FormData();

  Object.entries(clonedValues).forEach(([ key, value ]) => {
    if (key === 'data') {
      Object.entries(value).forEach(([ innerKey, innerValue ]) => {
        const fieldObj = fields.find((field) => field.full_name === innerKey);
        const fieldObjKey = fieldObj?.full_name;

        if (innerValue.hasOwnProperty('template_field_id') && innerValue.hasOwnProperty('value')) {
          formData.append(`${key}[${fieldObjKey}][template_field_id]`, innerValue.template_field_id);

          if (Array.isArray(innerValue.value)) {
            if (innerValue.value[0]?.hasOwnProperty(fileProp)) {
              formData.append(`${key}[${fieldObjKey}][value]`, innerValue.value[0][fileProp]);
            } else if (innerValue.value[0]?.hasOwnProperty('url') || !innerValue.value.length) {
              formData.append(`${key}[${fieldObjKey}][value]`, null);
            } else {
              innerValue.value.forEach((item) => {
                if (isObject(item)) {
                  Object.entries(item).forEach(([ itemKey, itemValue ]) => {
                    formData.append(`${key}[${fieldObjKey}][value][${itemKey}]`, itemValue);
                  });
                } else {
                  formData.append(`${key}[${fieldObjKey}][value][]`, item);
                }
              });
            }
          } else {
            const valueType = fields.find((field) => field.id === innerValue.template_field_id)?.type;

            if (valueType === TYPE_BOOLEAN && innerValue.value === null) {
              innerValue.value = false;
            }

            if (isObject(innerValue.value)) {
              Object.entries(innerValue.value).forEach(([ objKey, objValue ]) => {
                formData.append(`${key}[${fieldObjKey}][value][${objKey}]`, objValue);
              });
            } else {
              formData.append(`${key}[${fieldObjKey}][value]`, innerValue.value);
            }
          }
        }
      });
    } else if (key === 'target') {
      Object.entries(value).forEach(([ fieldObjKey, innerValue ]) => {
        if (isArray(innerValue)) {
          innerValue.forEach((item) => {
            if (isObject(item)) {
              Object.entries(item).forEach(([ itemKey, itemValue ]) => {
                formData.append(`${key}[${fieldObjKey}][${itemKey}]`, itemValue);
              });
            } else {
              formData.append(`${key}[${fieldObjKey}][]`, item);
            }
          });
        } else if (isObject(innerValue)) {
          Object.entries(innerValue).forEach(([ objKey, objValue ]) => {
            formData.append(`${key}[${fieldObjKey}][${objKey}]`, objValue);
          });
        } else {
          formData.append(`${key}[${fieldObjKey}]`, innerValue);
        }
      });
    } else if (Array.isArray(value)) {
      if (value[0]?.hasOwnProperty(fileProp)) {
        formData.append(key, value[0][fileProp]);
      } else if (value[0]?.hasOwnProperty('url')) {
        formData.append(key, null);
      } else {
        value.forEach((item) => {
          if (isObject(item)) {
            Object.entries(item).forEach(([ itemKey, itemValue ]) => {
              formData.append(`${key}[${itemKey}]`, itemValue);
            });
          } else {
            formData.append(`${key}[]`, item);
          }
        });
      }
    } else {
      appendToFormData(formData, key, value);
    }
  });

  return formData;
};

export default mkTemplateDynamicFormData;
